import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Root as Root$1 } from "@radix-ui/react-form";
import styles from "./form.module.css.js";
import classNames from "classnames";
const Root = forwardRef(
  function Root2({ children, ...props }, ref) {
    const classes = classNames(styles.root, props.className);
    return /* @__PURE__ */ jsx(Root$1, { ref, ...props, className: classes, children });
  }
);
export {
  Root
};
//# sourceMappingURL=Root.js.map
